"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitListUploadValidationSchema = exports.claimsValidationSchema = exports.claimValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.claimValidationSchema = (0, yup_1.object)().shape({
    account: yup_rules_eth_1.addressValidationSchema,
});
exports.claimsValidationSchema = (0, yup_1.object)().shape({
    items: (0, yup_1.array)().of(exports.claimValidationSchema).required("form.validations.valueMissing"),
});
exports.waitListUploadValidationSchema = (0, yup_1.object)().shape({
    files: (0, yup_1.array)().min(1, "form.validations.valueMissing"),
    listId: yup_rules_1.dbIdValidationSchema,
});
//# sourceMappingURL=validation.js.map